import UserProfileResponse from '@/store/models/user/user_profile_response';
import BraintreeClientTokenResponse from '@/store/models/subscriptions/braintree/braintree_client_token_response';
import ProductListResponse from '@/store/models/subscriptions/braintree/product_list_response';
import SalesPositionResponse from '@/store/models/subscriptions/braintree/sales_position_response';
import CancelSubscriptionResponse from '@/store/models/subscriptions/braintree/cancel_subscription_response';
import ProductResponse from '@/store/models/subscriptions/braintree/product_response';

import { fetchData, apiURL, getCurrencyExchange } from './api_helper';

const crypto = require('crypto');

const productList = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/subscriptions/product_list?provider=braintree`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const productListResponse = new ProductListResponse();
        productListResponse.map(result.response);
        resolve(productListResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getExchangeRate = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    // const endpointURL = `https://api.exchangeratesapi.io/latest?access_key=${process.env.VUE_APP_EXCHANGE_API_KEY}&base=USD&symbols=${payload}`;
    const endpointURL = `${apiURL}${apiLevel}/currencies/get_rate_with_symbol?symbol=${payload}`;
    fetchData(endpointURL, 'get', payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
    // getCurrencyExchange(endpointURL)
    //   .then((result) => {
    //     resolve(result);
    //   })
    //   .catch((error) => {
    //     reject(error);
    //   });
  });

const cancelSubscriptionFromBraintree = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/subscriptions/cancel_subscription_from_braintree`;
    fetchData(endpointURL, 'post', payload)
      .then((result) => {
        const cancelSubscription = new CancelSubscriptionResponse();
        cancelSubscription.map(result.response);
        resolve(cancelSubscription);
      })
      .catch((error) => {
        reject(error);
      });
  });

const cancelSubscriptionForDkt = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/subscriptions/cancel_subscription_for_dkt`;
    fetchData(endpointURL, 'post', payload)
      .then((result) => {
        const cancelSubscription = new CancelSubscriptionResponse();
        cancelSubscription.map(result.response);
        resolve(cancelSubscription);
      })
      .catch((error) => {
        reject(error);
      });
  });

const braintreeClientToken = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/subscriptions/braintree_client_token`;
    fetchData(endpointURL, 'get', payload)
      .then((result) => {
        const braintreeClientTokenResponse = new BraintreeClientTokenResponse();
        braintreeClientTokenResponse.map(result.response);
        decryptMessage(braintreeClientTokenResponse.clientToken).then((res) => {
          braintreeClientTokenResponse.clientToken = res;
        });
        resolve(braintreeClientTokenResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const verifyBraintreePayment = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/subscriptions/verify_braintree`;
    fetchData(endpointURL, 'post', payload)
      .then((result) => {
        const userProfileResponse = new UserProfileResponse();
        userProfileResponse.map(result.response);
        resolve(userProfileResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getProduct = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/subscriptions/product?provider=braintree&product_key=${payload}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const productResponse = new ProductResponse();
        productResponse.map(result.response);
        resolve(productResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getBestPriceId = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/users/check_product_sales?product_code=${payload}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
    });

const verifyCaptcha = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/subscriptions/verify_a_recaptcha`;
    fetchData(endpointURL, 'post', payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
    });

function decryptMessage(message) {
  return new Promise((resolve, rej) => {
    const decipher = crypto.createDecipheriv(
      'aes-256-cbc',
      process.env.VUE_APP_BRAINTREE_TOKEN_CIPHER_KEY,
      process.env.VUE_APP_BRAINTREE_TOKEN_CIPHER_IV,
    );

    let decryptedData = decipher.update(message, 'Base64', 'UTF-8');

    decryptedData += decipher.final('UTF-8');

    resolve(decryptedData);
  });
}

const rexProductList = apiLevel =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/subscriptions/product_list?provider=braintree`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const productListResponse = new ProductListResponse();
        productListResponse.map(result.response);
        resolve(productListResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

const salesPosition = (apiLevel, payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}${apiLevel}/subscriptions/sales_position?position=${payload.position}`;
    fetchData(endpointURL, 'get')
      .then((result) => {
        const salesPositionResponse = new SalesPositionResponse();
        salesPositionResponse.map(result.response);
        resolve(salesPositionResponse);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  cancelSubscriptionFromBraintree,
  braintreeClientToken,
  verifyBraintreePayment,
  productList,
  getProduct,
  getExchangeRate,
  cancelSubscriptionForDkt,
  getBestPriceId,
  verifyCaptcha,
  rexProductList,
  salesPosition,
};
